// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TextSearchPattern } from "../../text-search-pattern";

export class SearchRequestBase {
	public BasicSearchString: TextSearchPattern = new TextSearchPattern();
	public BasicSearchName: string = "";
	public BasicSearchDescription: string = "";
	public IsAdvancedSearchCapable: boolean = false;
	public IsAdvancedSearch: boolean = false;
}